import styled, { css } from 'styled-components';

import { colors } from '@crm-framework/theme';

import { OpenStatus } from './types';

export const TotalsContent = styled.div``;

export const TotalsGeneral = styled.div`
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid ${colors.DEFAULT_BORDER};
`;

export const TotalItemWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const TotalItemLabel = styled.div`
  font-weight: 600;
  margin-right: 5px;
`;

interface IStyleProps {
  height: string;
  isOpen: OpenStatus;
}

export const Wrapper = styled.section`
  width: 100%;
`;

const getContentDynamicStyle = ({ isOpen, height }: IStyleProps) => {
  if (isOpen) {
    return css`
      opacity: 1;
      user-select: initial;
      height: ${height};
    `;
  }

  return css`
    opacity: 0;
    user-select: none;
    height: 0;
    min-height: 0;
  `;
};

export const Content = styled.div<IStyleProps>`
  overflow: hidden;
  min-height: min-content;
  transition: opacity 0.4s ease-out;
  box-sizing: border-box;
  position: relative;
  ${getContentDynamicStyle};
`;
